/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {HISTORY_EVENT_ICON_BY_ASSET} from '../maps/constants';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Battery Low Icon component.
 */
export const BatteryLowIcon = (props: IconProps) => {
  const {iconSize} = useIconDLS(props);
  const {battLow}  = HISTORY_EVENT_ICON_BY_ASSET;

  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 10 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M5.57576 9.57576H4V4.84848H5.57576V9.57576ZM5.57576 12.8485H4V11.2727H5.57576V12.8485ZM8.60606 1.57576H7.27273V0H2.42424V1.57576H1.09091C0.484848 1.57576 0 2.06061 0 2.66667V14.9091C0 15.5152 0.484848 16 1.09091 16H8.48485C9.09091 16 9.57576 15.5152 9.57576 14.9091V2.66667C9.57576 2.06061 9.09091 1.57576 8.60606 1.57576Z'
        fill={battLow.color} />
    </svg>
  );
};
